import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import { useIsMobile } from "../hooks/useIsMobile";
import CloseIcon from "@mui/icons-material/Close";

interface MyDlgProps {
  title: string;
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

export function MyDlg({ title, open, onClose, children }: MyDlgProps) {
  const isMobile = useIsMobile();
  return (
    <Dialog 
      fullScreen={isMobile}
    open={open} 
    onClose={onClose} 
    fullWidth maxWidth="md">
      <DialogTitle>
        {title}

        {/* Close button */}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>{children}</DialogContent>
    </Dialog>
  );
}
